import React from "react";
import { Checkbox } from "../ui/checkbox";
import { Compass, AlertTriangle, Instagram } from "lucide-react";

const DP_LABELS = [["IG", "instagram"], ["FB", "facebook"], ["TT", "tiktok"], ["Web", "website"], ["Content", "content"]];

export const SuggestionCard = ({ it, index, checked, onToggle }) => (
  <label className={`card-lift flex cursor-pointer gap-3 rounded-xl border bg-card p-4 ${it.duplicate ? "border-yellow-500/40" : "border-border"}`} data-testid={`discover-item-${index}`}>
    <Checkbox checked={checked} onCheckedChange={(v) => onToggle(!!v)} className="mt-1" />
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-medium">{it.azienda}</span>
        {it.duplicate && (
          <span className="inline-flex items-center gap-1 rounded bg-yellow-500/15 px-1.5 py-0.5 text-[0.6rem] font-semibold text-yellow-500" data-testid={`discover-dup-${index}`}>
            <AlertTriangle className="h-2.5 w-2.5" /> POSSIBILE DOPPIONE
          </span>
        )}
      </div>
      <div className="mt-0.5 flex flex-wrap gap-x-2 text-xs text-muted-foreground">
        <span>{it.settore}</span><span>·</span>
        <span className="inline-flex items-center gap-1"><Compass className="h-3 w-3" />{it.citta}</span>
      </div>
      {it.opportunita && <p className="mt-2 text-sm text-foreground/80">{it.opportunita}</p>}
      {it.presenza_social && (
        <div className="mt-2 rounded-lg border border-border bg-secondary/30 px-2.5 py-1.5">
          <div className="mb-0.5 flex items-center gap-1 text-[0.6rem] font-semibold uppercase tracking-wide text-primary">
            <Instagram className="h-3 w-3" /> Presenza social
          </div>
          <p className="text-xs text-muted-foreground">{it.presenza_social}</p>
        </div>
      )}
      {it.digital_presence && (
        <div className="mt-2 flex flex-wrap gap-1">
          {DP_LABELS.map(([l, k]) => (
            <span key={l} className="rounded bg-secondary px-1.5 py-0.5 text-[0.6rem] text-muted-foreground">{l} <span className="text-foreground/80">{it.digital_presence[k] ?? 0}/10</span></span>
          ))}
        </div>
      )}
      {it.servizio_consigliato && (
        <span className="mt-2 inline-block rounded bg-primary/10 px-1.5 py-0.5 text-[0.65rem] text-primary">{it.servizio_consigliato}</span>
      )}
    </div>
  </label>
);
